// extracted by mini-css-extract-plugin
export default {"card":"card__1Ji-f","cardPicture":"cardPicture__1YdZJ","cardImg":"cardImg__1x7wH","cardContent":"cardContent__T6ELK","left":"left__30bG9","right":"right__1Jog6","cardTitle":"cardTitle__2KKYw","cardDescription":"cardDescription__2swnH","startingPrice":"startingPrice__3fXhj","price":"price__1vRUO","goToProductButton":"goToProductButton__2anA1"};
    if(module.hot) {
      // 1790586303690
      var cssReload = require("../../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  